export const blockIconsCommunicationCalendarAddOnNew = (
	<span className='material-symbols-outlined'>calendar_add_on</span>
);
